import { AfterContentInit, Component } from '@angular/core';

@Component({
  selector: 'knbr-kn-br-support',
  templateUrl: './kn-br-support.component.html',
  styleUrl: './kn-br-support.component.scss'
})

export class KnBrSupportComponent implements AfterContentInit {
  hbspt: any;

  ngAfterContentInit() {
    if ((window as any).hbspt && (window as any).hbspt.forms) {
        (window as any).hbspt.forms.create({
          portalId: "118964",
          formId: "728b2682-d161-4c73-bff6-1717b2242854",
          region: "na1",
          target: "#hubspotForm"
        });
      }
  }
}
